//@flow
import React from 'react';
import type {RepliedMessage} from '../../../../../../../../entities';
import {makeStyles, Typography} from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import VideocamIcon from '@material-ui/icons/Videocam';
import {colors} from '../../../../../../../../assets/styles/colors';

type Props = {
  message: RepliedMessage,
  onClick: (token: string) => void,
};

const useStyles = makeStyles(theme => ({
  replyingMessageWrapper: {
    padding: '.25rem',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderLeft: `4px solid ${colors.primary}`,
    backgroundColor: `${colors.grey200}69`,
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: `${colors.grey200}99`,
    },
  },
  content: {
    flexGrow: 1,
    paddingRight: theme.spacing(4),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    gap: theme.spacing(0.5),
  },
  typeIcon: {
    verticalAlign: 'middle',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
  },
}));

export default function ReplySnippet({message, onClick}: Props) {
  const classes = useStyles();

  const renderPreview = () => {
    switch (message.messageType) {
      case 'TEXT':
        return <Typography variant="body2">{message.text}</Typography>;
      case 'IMAGE':
        return (
          <>
            <ImageIcon className={classes.typeIcon} fontSize="small" />
            <Typography variant="body2">{message.text || 'Foto'}</Typography>
          </>
        );
      case 'VIDEO':
        return (
          <>
            <VideocamIcon className={classes.typeIcon} fontSize="small" />
            <Typography variant="body2">{message.text || 'Video'}</Typography>
          </>
        );
      case 'AUDIO':
        return (
          <>
            <AudiotrackIcon className={classes.typeIcon} fontSize="small" />
            <Typography variant="body2">{message.text || 'Audio'}</Typography>
          </>
        );
      case 'DOCUMENT':
        return (
          <>
            <InsertDriveFileIcon
              className={classes.typeIcon}
              fontSize="small"
            />
            <Typography variant="body2">
              {message.text || 'Documento'}
            </Typography>
          </>
        );
      default:
        return (
          <Typography variant="body2">
            {message.text || '[Empty message]'}
          </Typography>
        );
    }
  };

  return (
    <div className={classes.replyingMessageWrapper}>
      <div
        className={classes.container}
        onClick={() => onClick(message.messageReceivedAt)}
      >
        <div className={classes.content}>{renderPreview()}</div>
      </div>
    </div>
  );
}
